import { createAsyncThunk } from "@reduxjs/toolkit";

const prodURL = "/api";
const url =
  window.location.hostname === "localhost"
    ? "http://localhost:3004/api"
    : prodURL;

export const getHelpMessage = createAsyncThunk(
  "user/getHelpMessage",
  async function (props) {
    const { key } = props;

    const response = await fetch(`${url}/help`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        key: key,
      }),
    });

    const result = await response.text();
    return JSON.parse(result);
  }
);

export const getRules = createAsyncThunk(`user/getRules`, async function () {
  const response = await fetch(`${url}/rules`);

  const result = await response.text();

  return JSON.parse(result);
});

export const getInfo = createAsyncThunk(`user/getInfo`, async function () {
  const response = await fetch(`${url}/info`);

  const result = await response.text();

  return JSON.parse(result);
});

export const getInstruction = createAsyncThunk(
  `user/getInstruction`,
  async function () {
    const response = await fetch(`${url}/instruction`);

    const game = await response.text();

    return JSON.parse(game);
  }
);
